
const state = () => ({
  isshowPannel: false, // 是否显示播放器面板
  isShowPlayer: false, // 是否显示播放器, FM页面需要播放器, 但是不需要显示
  play_list: [],

  audio_type: 'pause', // 暂停、播放、准备 pause  play load
  current_multiplier_speed: 1, // 播放速度
  progress_current_unix:0, // 当前播放位置
  progress_all_unix:0, // 当前视频总时长
  progress_current_duration:"00:00",
  progress_all_duration:"00:00",

  is_show_play_list:false, // 是否显示播放器列表
  switch_play_type:1,     // 1|顺序播放、2|列表循环、3|单曲循环

  duration_time: 0,  // 播放时长
  current_sections_info:{},

  course_id:'',
  current_sections_id:'',
  cover:'',
  mytest:"1",

  showTab:false, // 是否显示TAb, 决定播放器位置
  reset_time: true, // 重置播放时长
  auto_play: true, // 是否自动播放，第一个不需要自动播放
})

// getters
const getters = {}

// actions
const actions = {
  initPlayList({commit,state}, list){
    commit("initList", list);
    state.isShowPlayer = true;
    state.isshowPannel = true;

  },
  setPlay({commit,state}, index){
    // 跟后台打交道
    // 调用mutaions里面的方法
    commit("setIndex", index);
  }
}

// mutations
const mutations = {
  setIndex(state, index){
    state.curr_section = state.lists[index];
  },
  initList(state, list){
    //state.play_list = list
    state.mytest = list
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}